import { Component, inject, input, output, viewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TypeAheadSelector2Component } from '../type-ahead-selector2/type-ahead-selector2.component';
import { map, Observable, of } from 'rxjs';
import { Organization, OrganizationSearchEvent } from 'src/app/features/organization/organization-models';
import { PagedResult } from '../../models/paging';
import OrganizationService from '../../services/organization.service';

@Component({
  selector: 'adm-org-typeahead',
  imports: [TypeAheadSelector2Component],
  templateUrl: './adm-org-typeahead.component.html',
  styleUrl: './adm-org-typeahead.component.scss',
})
export class AdmOrgTypeaheadComponent {
  private typeahead = viewChild(TypeAheadSelector2Component);
  organizationService = inject(OrganizationService);
  itemSelected = output<Organization | null>();
  initialId = input<number>();
  resetTrigger = input<{ reset: boolean }>();
  disabled = input<boolean>(false);
  required = input<boolean>(false);
  validationControl = input<AbstractControl | null>(null);
  requiredErrorText = input<string>('Organisation skal vælges fra listen');
  organizationsFetched = output<Organization[] | null>();
  clearTypeAhead = output();
  fetchOrganizations = (term: string): Observable<Organization[]> => {
    const searchEvent: OrganizationSearchEvent = {
      paging: { pageIndex: 0, pageSize: 1000, length: 0 },
      sorting: null,
      query: term.length > 0 ? term : undefined,
    };
    return this.organizationService.getOrganizations(searchEvent).pipe(
      map((result: PagedResult<Organization>) => {
        this.organizationsFetched.emit(result.items);
        return result.items;
      })
    );
  };

  fetchOrganizationById = (id: string): Observable<Organization | null> => {
    return this.organizationService.getOrganization(parseInt(id));
  };

  organizationSelected = (org?: Organization | null) => {
    this.itemSelected.emit(org ? org : null);
  };

  hasSelection(): boolean {
    return this.typeahead()?.selectedItem() != null;
  }

  refetch(orgId?: number): void {
    this.typeahead()?.refreshResults(orgId?.toString());
  }
}
